module.exports = __webpack_public_path__ + "static/media/summary_bg.1d8dcce7.png";